import React, { useState, useEffect } from "react";
import { Image, Row, Col, Table, Form } from "react-bootstrap";
import Media from "react-media";
import { NavLink } from "react-router-dom";
import { RightSideCountTop } from "../../../superAdminComponents/superAdminAllComponent/superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import ExperienceBody from "./ExperienceBody";
import { amApi } from "../../../../api/apiHelper";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import NoContent from "../../../reusableComponents/NoContentComponent";
import { SmallLoader } from "../../../Loader/SmallLoader";
import StatusFilter from "./Modals/StatusFilter";
import Container from "react-bootstrap/Container";

import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";
import SearchBar from "../../../reusableComponents/SearchBar";




const ExpiredExperiencesdashboard = () => {
  const history = useHistory();
  const [isActive, setActive] = useState(false);
  const [search, setSearch] = useState("");
  const [exptype, setexptype] = useState("SPECIAL");
  const [createpath, setcreatepath] = useState('')
  const [filterValueModel, setFiltervaluefromModal] = useState("");
  const [experience, setExperience] = useState({ data: null });

  const experiencevar = () => {
    if (history.location?.state?.exptype.includes('curated')) {
      setexptype('CURATED');
      setcreatepath('/createCurated');
    } else {
      setexptype('SPECIAL');
      setcreatepath('/createSpecial');
    }
    return 0;
  }




  useEffect(() => {
    async function fetchData() {
      //let stats = await amApi(`/experience?vendorStats=true&type=SPECIAL&requestType=ACTIVE`);
      let expData = await amApi(`/experience?requestType=EXPIRED&vendor=true&type=${exptype}`)
      //let statsAll = await amApi.get(`/expRequest?status=pending&type=STATS_BY_TYPE`);
      //let statsCount = await amApi.get(`/experience?type=expCount`);
      setExperience({ data: expData.data });
      experiencevar();
    }
    fetchData()
  }, [exptype])

  const removeExp = (id, active) => {
    let exp = experience.data.filter(ele => ele._id !== id);
    setExperience({ data: exp })
  }

  const updatePrimary = (id, type) => {
    let notPrimary = [...experience.data];
    if (type === "ACTIVE") {
      notPrimary = experience.data.map(ele => { return { ...ele, active: ele._id === id ? !ele.active : ele.active } });
    } else if (type === 'PRIMARY') {
      notPrimary = experience.data.map(ele => { return { ...ele, primary: ele._id === id ? !ele.primary : false } });
    }
    setExperience({ stats: experience.stats, data: notPrimary })
  }


  let filteredData = experience?.data;
  if (search) {
    let searchData = new RegExp(search, "i");
    filteredData = experience?.data.filter((getall) => {
      if (searchData.test(getall?.name) || searchData.test(getall?.expId) || searchData.test(getall?.category?.title) || searchData.test(getall?.subCategory?.title)) {
        return getall;

      } else {
        return false;
      }
    });
  }

  filteredData = filteredData?.filter((getall) => {
    if (filterValueModel === "All" || filterValueModel === "") {
      return true;
    } else {
      return getall.active === filterValueModel;
    }
  });


  return (
    <React.Fragment>
      <Container fluid>
        <Row>
          <Media query="(min-width: 992px)">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
          </Media>
          <div className="right-side-panel">
            <RightSideNavigation
              pageTitle={`Expired Experiences`}
              pageDesc={'You can see all the experiences which are expired'}
              history={history}
              leftText={"history"}
              displayText={'Back'} />
            <Container fluid className="p-0">
              <Media query="(min-width: 992px)">
                <div className="container-fluid seating_dashboard_top_new_header">
                  <Row className="mt-4">
                    <Col md={5} className="d-flex align-items-center">
                      <SearchBar onChange={setSearch} />
                      <div className="f10-400" align="center">
                        <img
                          src={require("../../../../assets/images/iconButton/downloadbtn.svg")}
                          width="48px"
                        />
                      </div>
                    </Col>
                    <Col md={3}></Col>
                    <Col md={4}>
                      {/* <RightSideCountTop
                content={[
                  {
                    name: "Inactive Experiences",
                    value: experience?.stats?.inActiveCount || 0,
                    backgroundColor: "#EFEBFB",
                    color: "#6F32C9",
                  },
                  {
                    name: "Active Experiences",
                    value: experience?.stats?.activeCount || 0,
                    backgroundColor: "#D8F3F4",
                    color: "#138B90",
                  },
                ]}
              /> */}
                    </Col>
                  </Row>
                  <Media query="(min-width: 992px)">
                    <div className="user-table-reusable-superadmin table-responsive">
                      <Table>
                        <thead style={{ position: 'sticky', top: '2px', zIndex: 10 }}>
                          <tr className="super_admin_all_users_table_head">
                            <td style={{ width: "2%" }} className="f12-400">

                            </td>
                            <td style={{ width: "20%" }} className="f12-400">
                              My Experience/
                              <br /> Experience ID
                            </td>
                            <td style={{ width: "20%" }} className="f12-400">
                              Start Date
                              <br />
                              End date
                            </td>
                            <td style={{ width: "15%" }} className="f12-400">
                              Pricing
                            </td>
                            <td style={{ width: "15%" }} className="f12-400">
                              User | Left
                              <br /> Count
                            </td>
                            <td style={{ width: "15%" }} className="f12-400">
                              Venue
                            </td>
                            <td style={{ width: "20%" }} className="f12-400 text-center">
                              Actions
                            </td>
                            <td style={{ width: "20%" }} className="f12-400 text-center">
                              More Actions
                            </td>
                          </tr>
                        </thead>
                        {!filteredData ? <SmallLoader />
                          : filteredData?.length === 0 ? <NoContent />
                            : filteredData.map(exp => <ExperienceBody exp={exp} removeExp={removeExp} updatePrimary={updatePrimary} />
                            )}
                      </Table>
                    </div>
                  </Media>
                </div>
              </Media>
            </Container>
          </div>
          <Media query="(max-width: 991px)">
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </Media>
        </Row>
      </Container>

    </React.Fragment >
  );
};

export default ExpiredExperiencesdashboard;
